import { connect } from 'react-redux';
import Search from '../../components/search';
import {
    toggleSearch,
    closeSearch,
    fetchSearchResultsThunk,
    filterSearchResultsThunk,
    resetSearchResults
} from '../../actions';

import {
    getIsSearchFilterOpen,
    getSearchQuery,
    getSearchResults,
    getSearchActive,
    getSearchResultsNumber,
    getSearchLoading
} from '../../reducers';

const mapStateToProps = state => ({
    searchActive: getSearchActive(state),
    searchQuery: getSearchQuery(state),
    searchLoading: getSearchLoading(state),
    searchResults: getSearchResults(state),
    searchResultsNumber: getSearchResultsNumber(state),
    isSearchFilterOpen: getIsSearchFilterOpen(state),
    fromDate: state.search.startDate
});

const mapDispatchToProps = dispatch => ({
    toggleSearch: () => dispatch(toggleSearch()),
    closeSearch: () => dispatch(closeSearch()),
    fetchSearchResultsThunk: query => dispatch(fetchSearchResultsThunk(query)),
    resetSearchResults: () => dispatch(resetSearchResults()),
    filterSearchResultsThunk: filters =>
        dispatch(filterSearchResultsThunk(filters))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./src/containers/search/index.js